import {Component, Inject, OnInit} from '@angular/core';
import {DialogInputData} from "../dialog-input/dialog-input.component";
import {FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IconPickerModel} from "../icon-picker/icon-picker.component";

/**
 * Dialog data
 */
export class DialogInputIconData extends DialogInputData {

  /** Pre defined icon */
  icon: string;

  /** Pre defined icon unicode */
  iconUnicode: string;

  constructor(title: string, placeholder = '', text = '', icon='', iconUnicode = '') {
    super(title, placeholder, text);
    this.icon = icon;
    this.iconUnicode = iconUnicode;
  }
}

/**
 * Delete dialog template
 *
 * Using with MatDialog:
 *
 ```
 // Open dialog
 const dialogRef = this.dialog.open(DialogInputIconComponent, {
     data: new DialogInputIconData('Type here!')
 });

 // Callback for when dialog is closed
 const result = dialogRef.afterClosed().toPromise()
 ```
 */
@Component({
  selector: 'kis-dialog-input-icon',
  templateUrl: './dialog-input-icon.component.html',
  styleUrls: ['./dialog-input-icon.component.scss']
})
export class DialogInputIconComponent implements OnInit {

  /** Dialog input form */
  form = new FormGroup({
    text: new FormControl(''),
    icon: new FormControl({})
  });

  /**
   * @param dialogRef - to use dialog operations
   * @param data - data to be injected
   */
  constructor(public dialogRef: MatDialogRef<DialogInputIconComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogInputIconData) {
    if (data.text) {
      this.form.get('text').setValue(data.text);
      this.form.get('icon').setValue(new IconPickerModel(data.icon, data.iconUnicode));
    }
  }


  ngOnInit(): void {
  }

  submit() {
    this.dialogRef.close(this.form.value);
  }

}
